module.exports = __webpack_public_path__ + "img/entreprise.a8dc14ff.jpg";